import interactWithUSComments from "../../config/liveFirebase";
import checkDateExists from "./checkDateExists";

function formatDate(date) {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

function getDateRangeArray(startDate, endDate) {
  const dateArray = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  for (let d = new Date(end); d >= start; d.setDate(d.getDate() - 1)) {
    dateArray.push(formatDate(new Date(d)));
  }

  return dateArray;
}

const structureNMRData = async (
  projectIds,
  startDate,
  endDate,
  setProcessedDays
) => {

  // console.log('projectIds before pushing : ', projectIds);
  // projectIds.push([1729340392211, 'Gudebellure mine']);
  // console.log('projectIds after adding mine : ', projectIds);
  
  const dateRange = getDateRangeArray(startDate, endDate);
  const totalProjects = projectIds.length;
  const totalDates = dateRange.length;
  

  let sampleData = {};

  for (let i = 0; i < totalProjects; i++) {
    const [projectId, projectName] = projectIds[i];
    sampleData[projectName] = {};

    setProcessedDays((prev) => Math.max(prev, i + 0.05));

    // 🧠 Artificial tiny wait to let UI reflect progress
    await new Promise((resolve) => setTimeout(resolve, 100)); // gives time for render

    // 🔄 API Call
    let projectData = null;
    try {
      const response = await interactWithUSComments("GET", projectId);
      projectData = response?.data || null;
    } catch (err) {
      console.error(`Error fetching data for project ${projectId}`, err);
      continue;
    }

    // 💡 Another partial update after API call
    setProcessedDays((prev) => Math.max(prev, i + 0.25));
    await new Promise((resolve) => setTimeout(resolve, 80));

    // ⏱ Loop through dates with small progress bumps
    for (let j = 0; j < totalDates; j++) {
      const date = dateRange[j];
      const exists = checkDateExists(date, projectData);
      // sampleData[projectName][date] = exists.exists ? "Yes" : "No";
      sampleData[projectName][date] = {
        exists : exists.exists ? "yes" : "no",
        totalAssignWorkWithImages: exists.totalAssignWorkWithImages,
        totalAssignWorkOne: exists.totalAssignWorkOne,
      };

      const fractionalProgress = i + (j + 1) / (totalDates + 2);
      setProcessedDays(fractionalProgress);
    }

    // ✅ Final update for this project
    setProcessedDays(i + 1);
  }

  return sampleData;
};


export default structureNMRData;
